import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import React from 'react';
import { IMortgagePropertyRates } from '../../../types/mortgage/data';
import { cssUrlValue } from './cssUrlValue';
import { formatRate } from './formatRate';
import * as styles from './MainpageMortgageContainer.css';
import { PRODUCT_TILES, PROGRAM_TILES, SOCIAL_STEPS } from './mortgageBlockContent';
import {
  MAINPAGE_MORTGAGE_GOS_HELP_BUTTON_HREF,
  MAINPAGE_MORTGAGE_HOW_WORKS_BUTTON_HREF,
  MAINPAGE_MORTGAGE_BUTTON_HREF,
  trackMainpageMortgageGosHelpButtonClick,
  trackMainpageMortgageGosHelpButtonShow,
  trackMainpageMortgageHowWorksButtonClick,
  trackMainpageMortgageHowWorksButtonShow,
  trackMainpageMortgageButtonClick,
  trackMainpageMortgageButtonShow,
} from './tracking';

export interface IMainpageMortgageContainerProps {
  rates?: Partial<IMortgagePropertyRates>;
}

const DEFAULT_RATES: IMortgagePropertyRates = {
  newBuilding: 4.7,
  used: 10.6,
  cottage: 11.3,
  land: 12,
};

export const MainpageMortgageContainer: React.FC<IMainpageMortgageContainerProps> = ({ rates }) => {
  const normalizedRates = { ...DEFAULT_RATES, ...rates };

  return (
    <div className={styles.container}>
      <div className={styles.block}>
        <h2 className={styles.sectionTitle}>Ипотека на все виды недвижимости</h2>
        <div className={styles.productRow}>
          {PRODUCT_TILES.map(tile => (
            <div key={tile.rateKey} className={styles.productItem}>
              <div
                className={styles.productCard}
                style={{ ['--imageSrc' as string]: cssUrlValue(tile.imageSrc) } as React.CSSProperties}
              >
                <div className={styles.productText}>
                  <span>от</span>
                  <span className={styles.productRate}>{formatRate(normalizedRates[tile.rateKey])}%</span>
                  <span>{tile.label}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ActionAfterViewObserver callback={trackMainpageMortgageButtonShow} triggerOnce wrapperClass={styles.ctaRow}>
          <a
            className={styles.primaryButton}
            href={MAINPAGE_MORTGAGE_BUTTON_HREF}
            rel="noopener noreferrer"
            target="_blank"
            onClick={trackMainpageMortgageButtonClick}
          >
            Получить предложения банков
          </a>
        </ActionAfterViewObserver>
      </div>

      <div className={styles.block}>
        <h2 className={styles.sectionTitle}>Все виды ипотеки с господдержкой</h2>
        <div className={styles.programRow}>
          {PROGRAM_TILES.map(program => (
            <div key={program.name} className={styles.programItem}>
              <div
                className={styles.programCard}
                style={{ ['--imageSrc' as string]: cssUrlValue(program.imageSrc) } as React.CSSProperties}
              >
                <div className={styles.programRate}>{formatRate(program.rate)}%</div>
                <div>{program.name}</div>
              </div>
            </div>
          ))}
        </div>
        <ActionAfterViewObserver
          callback={trackMainpageMortgageGosHelpButtonShow}
          triggerOnce
          wrapperClass={styles.ctaRow}
        >
          <a
            className={styles.primaryButton}
            href={MAINPAGE_MORTGAGE_GOS_HELP_BUTTON_HREF}
            rel="noopener noreferrer"
            target="_blank"
            onClick={trackMainpageMortgageGosHelpButtonClick}
          >
            Подать заявку онлайн
          </a>
        </ActionAfterViewObserver>
      </div>

      <div className={styles.block}>
        <h2 className={styles.sectionTitle}>Как работает Циан.Ипотека</h2>
        <div className={styles.socialRow}>
          {SOCIAL_STEPS.map((step, idx) => (
            <div key={step.title} className={styles.socialItem}>
              <div className={styles.socialPoint}>
                <div className={styles.socialStep}>{idx + 1}</div>
                <div>
                  <h3 className={styles.socialHeading}>{step.title}</h3>
                  <span className={styles.socialDescription}>{step.description}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ActionAfterViewObserver
          callback={trackMainpageMortgageHowWorksButtonShow}
          triggerOnce
          wrapperClass={styles.ctaRow}
        >
          <a
            className={styles.primaryButton}
            href={MAINPAGE_MORTGAGE_HOW_WORKS_BUTTON_HREF}
            rel="noopener noreferrer"
            target="_blank"
            onClick={trackMainpageMortgageHowWorksButtonClick}
          >
            Подать заявку онлайн
          </a>
        </ActionAfterViewObserver>
      </div>
    </div>
  );
};
